import { Card, CardContent } from "@/components/ui/card";
import { Shield } from "lucide-react";
import {
  PrivacyPermissionsForm,
  PrivacyPermissionsFormValue,
} from "@/components/applications/pppc/PrivacyPermissionsForm";

interface PppcStepProps {
  bundleId: string;
  appName: string;
  value: PrivacyPermissionsFormValue;
  onChange: (next: PrivacyPermissionsFormValue) => void;
  errors?: { codeRequirement?: string };
  disabled?: boolean;
  disabledReason?: string;
}

export const PppcStep = ({
  bundleId,
  appName,
  value,
  onChange,
  errors,
  disabled = false,
  disabledReason,
}: PppcStepProps) => {
  return (
    <div className="max-w-3xl mx-auto">
      <div className="mb-6">
        <div className="flex items-center gap-2 mb-2">
          <Shield className="h-5 w-5 text-primary" />
          <h2 className="text-lg font-semibold">Privacy Permissions (Optional)</h2>
        </div>
        <p className="text-sm text-muted-foreground">
          Pre-approve or deny <strong>{appName}</strong>'s access to macOS privacy
          services. Optional — configure now or later from the app's detail page.
        </p>
      </div>

      <Card>
        <CardContent className="pt-6">
          <PrivacyPermissionsForm
            bundleId={bundleId}
            value={value}
            onChange={onChange}
            errors={errors}
            scrollServices={false}
            disabled={disabled}
            disabledReason={disabledReason}
          />
        </CardContent>
      </Card>
    </div>
  );
};
